export const departmentOptions = [
  { value: "engineering", label: "Engineering" },
  { value: "product", label: "Product" },
  { value: "design", label: "Design" },
  { value: "sales", label: "Sales" },
  { value: "marketing", label: "Marketing" },
  { value: "human-resources", label: "Human Resources (HR)" },
  { value: "finance", label: "Finance" },
  { value: "operations", label: "Operations" },
  { value: "customer-support", label: "Customer Support" },
  { value: "legal-compliance", label: "Legal & Compliance" },
  { value: "executive", label: "Executive" },
  { value: "it-security", label: "IT & Security" },
  { value: "admin-facilities", label: "Admin & Facilities" },
]